var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"headline":"Resend Invite","htmlInfo":_vm.info,"avatar":{
      firstName: _vm.user?.firstName,
      lastName: _vm.user?.lastName
    },"actionLabel":"Resend","data-testid":"resend-invite-admin-user-popup","destructive":false,"persistent":_vm.$loader.isAppLoading},on:{"input":function($event){return _vm.$emit('onClose')},"onAction":function($event){return _vm.$emit('onResendInviteAdminUser')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }